import React from 'react';
import PropTypes from 'prop-types';
import TestBackend from '../../../DragDropContextProvider/TestBackend';
import DragDropContextProvider from '../../../DragDropContextProvider';
// Apply TestBackend for drag and drop on test environment
const isTestEnv = process.env.NODE_ENV === 'test';
class DraggableManager extends React.Component {
    render() {
        const { dataHook, children } = this.props;
        return (React.createElement("div", { "data-hook": dataHook },
            React.createElement(DragDropContextProvider, { backend: isTestEnv ? TestBackend : undefined }, children)));
    }
}
DraggableManager.propTypes = {
    children: PropTypes.node,
    dataHook: PropTypes.string,
};
export default DraggableManager;
//# sourceMappingURL=DraggableManager.js.map